export default __webpack_public_path__ + "static/media/mobile-yield.6dc43fae.png";